export default {
    getAllPicks: function(outgoingPicks, managerName) {
        let pickList = {
                2027: [],
                2028: [],
                2029: [],
                2030: [],
            };
        //build out initial list
        let userManagerOutgoingPicks = outgoingPicks[managerName];
        Object.keys(pickList).forEach(year => {
            for (let i = 1; i <= 7; i++) {
                if(!(userManagerOutgoingPicks && userManagerOutgoingPicks[year] && userManagerOutgoingPicks[year][i])) {
                    pickList[year].push([managerName]);
                } else {
                    pickList[year].push([]);
                }
            }
        })
        Object.keys(outgoingPicks).forEach(managerOutgoingPickName => {
            if(managerOutgoingPickName !== managerName) {
                let managerOutgoingPicks = outgoingPicks[managerOutgoingPickName];
                Object.keys(managerOutgoingPicks).forEach(year => {
                    let managerOutgoingPicksYear = managerOutgoingPicks[year];
                    Object.keys(managerOutgoingPicksYear).forEach(round => {
                        if (managerOutgoingPicksYear[round] === managerName) {
                            pickList[year] && pickList[year][round-1].push(managerOutgoingPickName);
                        }
                    });
                });
            }
        });
        return pickList;
    },
    getOrdinal: function(num) {
        if (num === 1) return '1st';
        if (num === 2) return '2nd';
        if (num === 3) return '3rd';
        return num + 'th';
    },
    getPickCountsByYear: function(managerPicks) {
        let counts = {};
        Object.keys(managerPicks).forEach(year => {
            counts[year] = managerPicks[year].reduce((sum, round) => sum + round.length, 0);
        });
        return counts;
    },
    // e.g. "1 1st, 3 2nds, 1 5th"
    getPickRoundSummary: function(yearRounds) {
        return yearRounds
            .map((round, index) => ({ round: index + 1, count: round.length }))
            .filter(r => r.count > 0)
            .map(r => `${r.count} ${this.getOrdinal(r.round)}${r.count !== 1 ? 's' : ''}`)
            .join(', ');
    },
    // Cumulative, year-by-year projection of roster size following each future draft.
    // roster: this manager's current players (including injured), each with `contract` and `yahooleaguerank`.
    // managerPicks: getAllPicks() output for this manager.
    getRosterProjections: function(roster, managerPicks) {
        const years = Object.keys(managerPicks).sort((a, b) => Number(a) - Number(b));

        let realPlayers = roster.map(p => ({ ...p, contractRemaining: p.contract || 0 }));
        let hypotheticalPicks = [];

        let projectionsByYear = {};

        years.forEach(year => {
            realPlayers.forEach(p => { p.contractRemaining -= 1; });

            const expiring = realPlayers.filter(p => p.contractRemaining <= 0);
            let staying = realPlayers.filter(p => p.contractRemaining > 0);

            let taggedSave = null;
            if (expiring.length > 0) {
                taggedSave = expiring.reduce((best, p) => {
                    const rank = p.yahooleaguerank || Infinity;
                    const bestRank = best ? (best.yahooleaguerank || Infinity) : Infinity;
                    return rank < bestRank ? p : best;
                }, null);
            }

            const departing = expiring.filter(p => p !== taggedSave);

            if (taggedSave) {
                taggedSave.contractRemaining = 1;
                staying = staying.concat([taggedSave]);
            }

            realPlayers = staying;

            const picksAddedThisYear = [];
            managerPicks[year].forEach((round, roundIndex) => {
                round.forEach(originalOwner => {
                    picksAddedThisYear.push({ year, round: roundIndex + 1, originalOwner });
                });
            });
            hypotheticalPicks = hypotheticalPicks.concat(picksAddedThisYear);

            projectionsByYear[year] = {
                rosterSize: realPlayers.length + hypotheticalPicks.length,
                returning: realPlayers.filter(p => p !== taggedSave),
                taggedSave: taggedSave,
                departing: departing,
                picksAddedThisYear: picksAddedThisYear.length,
                hypotheticalPicks: hypotheticalPicks,
            };
        });

        return projectionsByYear;
    },
    STARTING_SLOTS: [
        { label: 'QB', count: 1, filter: p => p.posname === 'QB' },
        { label: 'RB', count: 2, filter: p => p.posname === 'RB' },
        { label: 'WR', count: 2, filter: p => p.posname === 'WR' },
        { label: 'TE', count: 1, filter: p => p.posname === 'TE' },
        { label: 'Flex', count: 1, filter: p => ['RB', 'WR', 'TE'].includes(p.posname) },
        { label: 'DEF', count: 1, filter: p => p.posname === 'DEF' },
        { label: 'K', count: 1, filter: p => p.posname === 'K' },
    ],
    // Greedily fills starting slots (best yahooleaguerank first), everyone else is bench.
    getStartingLineupAndBench: function(players) {
        const sorted = players.slice().sort((a, b) => (a.yahooleaguerank || 9999) - (b.yahooleaguerank || 9999));
        const usedIds = new Set();
        const starters = [];
        this.STARTING_SLOTS.forEach(slot => {
            const available = sorted.filter(p => slot.filter(p) && !usedIds.has(p.id));
            for (let i = 0; i < slot.count; i++) {
                const player = available[i] || null;
                if (player) usedIds.add(player.id);
                starters.push({ label: slot.label, player: player });
            }
        });
        const bench = sorted.filter(p => !usedIds.has(p.id));
        return { starters, bench };
    },
}